module.exports = __webpack_public_path__ + "static/media/pic5.bae21594.jpg";